import React from "react";
import { NavLink } from "react-router-dom";
import AuthContext from '../store/AuthContext';
import ListGroup from 'react-bootstrap/ListGroup';
import { BsSearch, BsBookmarksFill, BsFillInfoCircleFill } from 'react-icons/bs';
import { BiSolidShoppingBag, BiSolidBook } from 'react-icons/bi';
import { FaEnvelope, FaCog} from 'react-icons/fa';
import { LuCog } from "react-icons/lu";
import './SidePanel.css';

export const SidePanel: React.FC = () => {
    const authCtx = React.useContext(AuthContext);

    return (
        <div className="side-panel">
        <ListGroup>
            <ListGroup.Item>
                <NavLink to="/saved">
                    <BsBookmarksFill/>
                    Favourites
                </NavLink>
            </ListGroup.Item>
            <ListGroup.Item className="separator"></ListGroup.Item>
            <ListGroup.Item>
                <NavLink to="/own-dimensions">
                    <LuCog/>
                    Creative Studio
                </NavLink>
            </ListGroup.Item>
            <ListGroup.Item>
                <a className="disabled" href="#">
                    <BiSolidShoppingBag/>
                    Asset Store
                </a>
            </ListGroup.Item>
            <ListGroup.Item>
                <a href="https://docs.dimx.world" target="_blank">
                    <BiSolidBook/>
                    Documentation
                </a>
            </ListGroup.Item>
            <ListGroup.Item className="separator"></ListGroup.Item>
            <ListGroup.Item>
                <a href="https://dimx.world" target="_blank">
                    <BsFillInfoCircleFill/>
                    How It Works
                </a>
            </ListGroup.Item>
            <ListGroup.Item>
                <a href="https://dimx.world#contact" target="_blank">
                    <FaEnvelope/>
                    Contact Us
                </a>
            </ListGroup.Item>
            <ListGroup.Item className="separator"></ListGroup.Item>
            {authCtx.account.settings && (
                <ListGroup.Item>
                    <NavLink to="/settings">
                        <FaCog/>
                        Settings
                    </NavLink>
                </ListGroup.Item>
            )}
            <ListGroup.Item className="separator"></ListGroup.Item>
            <ListGroup.Item>
                <a href="https://apps.apple.com/us/app/dimensionx-app/id1540590200" target="_blank">
                    <img src="img/apple_appstore.png" className="download-button"/>
                </a>
            </ListGroup.Item>
            <ListGroup.Item>
                <a href="https://play.google.com/store/apps/details?id=world.dimx.app" target="_blank">
                    <img src="img/google_play.png" className="download-button"/>
                </a>
            </ListGroup.Item>
        </ListGroup>
        </div>
    );
};
